// src/components/EventList.js
import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import headerImage from "../assets/header.jpg";
/*import EditEventForm from "./EditEventForm";*/
import Seo from "./Seo";
import "./EventList.css";
import EventDetailsModalTW from "./EventDetailsModalTW";

/* Partnernek küldhető ID alapú (ajánlott — gyorsabb, egyértelmű) mintakód: 

<iframe
  src="https://lelkigyakorlatok.vercel.app/?embed=1&communityId=6"
  style="width:100%;height:700px;border:0;overflow:hidden"
  loading="lazy">
</iframe>

*/
/*Partnernek küldhető Community alapú (ajánlott — gyorsabb, egyértelmű) mintakód
<iframe
  src="https://lelkigyakorlatok.vercel.app/?embed=1&community=martineum"
  style="width:100%;height:700px;border:0;overflow:hidden"
  loading="lazy">
</iframe>

*/

/* =========================
   GA4 + UTM segédfüggvények
   ========================= */
const gaEvent = (name, params = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", name, params);
  }
};

const appendUTM = (url, params) => {
  const u = new URL(url);
  Object.entries(params || {}).forEach(([k, v]) => u.searchParams.set(k, v));
  return u.toString();
};

const SHARE_CAMPAIGN = "launch";

const gaShare = (network, ev) => {
  gaEvent("share_click", {
    event_category: "share",
    event_label: network, // 'facebook' | 'whatsapp' | 'gmail' | 'email' | 'native'
    value: 1,
    event_id: String(ev?.id || ""),
    title: ev?.title || "",
    target_group: ev?.target_group || "",
  });
};

const CANONICAL_BASE = "https://lelkigyakorlatok.vercel.app";
const makeLanding = (ev, source) =>
  appendUTM(`${CANONICAL_BASE}/api/share?id=${ev.id}`, {
    utm_source: source,
    utm_medium: "share_button",
    utm_campaign: SHARE_CAMPAIGN,
  });

/* ==============
   Ikon komponensek
   ============== */
   
   const CalendarIcon = ({ size = 18, className = "" }) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4.5" width="18" height="16" rx="2.5"></rect>
    <path d="M8 2.5v4M16 2.5v4M3 9.5h18"></path>
    <rect x="7.5" y="12" width="3.5" height="3.5" rx="0.75"></rect>
  </svg>
);

const IconFacebook = (props) => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path
      fill="currentColor"
      d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.14 8.44 9.94v-7.03H7.9v-2.9h2.54V9.41c0-2.5 1.48-3.9 3.75-3.9 1.09 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.77l-.44 2.9h-2.33V22c4.78-.8 8.44-4.94 8.44-9.94Z"
    />
  </svg>
);
const IconMail = (props) => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path
      fill="currentColor"
      d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 4-8 5L4 8V6l8 5 8-5v2Z"
    />
  </svg>
);
const IconWhatsApp = (props) => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path
      fill="currentColor"
      d="M20.52 3.48A11.86 11.86 0 0 0 12.05 0C5.45 0 .14 5.3.14 11.92c0 2.1.55 4.15 1.61 5.96L0 24l6.28-1.64a12 12 0 0 0 5.76 1.47h.01c6.6 0 11.92-5.31 11.92-11.92 0-3.19-1.24-6.19-3.45-8.43ZM12.05 22a9.99 9.99 0 0 1-5.1-1.4l-.37-.22-3.73.97.99-3.64-.24-.37a10.02 10.02 0 1 1 8.45 4.66Zm5.48-7.43c-.3-.15-1.77-.87-2.05-.96-.27-.1-.47-.15-.67.15-.2.3-.77.95-.94 1.14-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.74-1.64-2.03-.17-.3-.02-.46.13-.61.14-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.6-.92-2.18-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.05 1.02-1.05 2.48 0 1.46 1.08 2.87 1.22 3.07.15.2 2.12 3.23 5.15 4.53.72.31 1.28.49 1.72.63.72.23 1.37.2 1.88.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z"
    />
  </svg>
);
const IconGmail = (props) => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <rect x="2" y="4" width="20" height="16" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path d="M4 8.2 L12 13 L20 8.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path d="M6 17 V9.2 L12 13.2 L18 9.2 V17" fill="none" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);
const IconShareNative = (props) => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <path fill="currentColor" d="M16 5l-4-4-4 4h3v6h2V5h3zm2 14H6v-7H4v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7h-2v7z" />
  </svg>
);

/* ==================
   Megosztó szövegek
   ================== */
const buildEmailSubject = (event) => `Ajánlott lelkigyakorlat: ${event?.title || "Esemény"}`;

const buildEmailBody = (event, landingUrl) => {
  const whenStart = event?.start_date ? new Date(event.start_date).toLocaleString("hu-HU") : "";
  const whenEnd = event?.end_date ? new Date(event.end_date).toLocaleString("hu-HU") : "";
  const when = whenStart ? `Időpont: ${whenStart}${whenEnd ? ` – ${whenEnd}` : ""}\n` : "";
  const loc = event?.location ? `Helyszín: ${event.location}\n` : "";
  const reg = event?.registration_link ? `Jelentkezés: ${event.registration_link}\n` : "";
  return `${event?.title || "Esemény"}\n${when}${loc}${reg}\nRészletek:\n${landingUrl}`;
};

const buildGmailShare = (ev, to = "") => {
  const landing = makeLanding(ev, "gmail");
  const su = encodeURIComponent(buildEmailSubject(ev));
  const bodyRaw = buildEmailBody(ev, landing);
  const toParam = encodeURIComponent(to || "");
  return `https://mail.google.com/mail/?view=cm&fs=1&to=${toParam}&su=${su}&body=${encodeURIComponent(bodyRaw)}`;
};

const buildMailto = (ev, to = "") => {
  const landing = makeLanding(ev, "email");
  const su = encodeURIComponent(buildEmailSubject(ev));
  const body = encodeURIComponent(buildEmailBody(ev, landing));
  const toParam = encodeURIComponent(to || "");
  return `mailto:${toParam}?subject=${su}&body=${body}`;
};

/* ==========================
   Mobil felismerés (WebShare)
   ========================== */
const isMobileUA = typeof navigator !== "undefined" ? /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) : false;
const canWebShare = isMobileUA && typeof navigator !== "undefined" && !!navigator.share;

/* ==========
   JSON-LD segédek
   ========== */
const buildEventJsonLd = (ev, canonicalBase = CANONICAL_BASE) => {
  const startISO = ev?.start_date ? new Date(ev.start_date).toISOString() : undefined;
  const endISO = ev?.end_date ? new Date(ev.end_date).toISOString() : undefined;
  const url = `${canonicalBase}/api/share?id=${ev.id}`;

  const images = [];
  if (ev?.poster_url) images.push(ev.poster_url);
  else if (ev?.image_url) images.push(ev.image_url);

  return {
    "@context": "https://schema.org",
    "@type": "Event",
    name: ev?.title || "Lelkigyakorlat",
    startDate: startISO,
    ...(endISO ? { endDate: endISO } : {}),
    eventStatus: "https://schema.org/EventScheduled",
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    description: (ev?.description || "").slice(0, 1000),
    ...(images.length ? { image: images } : {}),
    location: {
      "@type": "Place",
      name: ev?.location || "Lelkigyakorlat helyszíne",
      address: ev?.location || "Magyarország",
    },
    organizer: {
      "@type": "Organization",
      name: ev?.communities?.name || "Szervező közösség",
    },
    url,
  };
};

const buildItemListJsonLd = (events, canonicalBase = CANONICAL_BASE) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: events.map((ev, i) => ({
    "@type": "ListItem",
    position: i + 1,
    url: `${canonicalBase}/api/share?id=${ev.id}`,
    name: ev?.title || `Esemény #${ev.id}`,
  })),
});

/* ==========
   ICS (naptár)
   ========== */
const pad2 = (n) => String(n).padStart(2, "0");
const toIcsDate = (d) => {
  const dt = new Date(d);
  const y = dt.getUTCFullYear();
  const m = pad2(dt.getUTCMonth() + 1);
  const day = pad2(dt.getUTCDate());
  const hh = pad2(dt.getUTCHours());
  const mm = pad2(dt.getUTCMinutes());
  const ss = pad2(dt.getUTCSeconds());
  return `${y}${m}${day}T${hh}${mm}${ss}Z`;
};

const buildIcs = (ev) => {
  const uid = `event-${ev.id}@lelkigyakorlatok.vercel.app`;
  const dtStart = ev.start_date ? toIcsDate(ev.start_date) : toIcsDate(new Date());
  const dtEnd = ev.end_date ? toIcsDate(ev.end_date) : dtStart;
  const desc = [
    ev.description || "",
    ev.registration_link ? `Jelentkezés: ${ev.registration_link}` : "",
    `${CANONICAL_BASE}/api/share?id=${ev.id}`,
  ]
    .filter(Boolean)
    .join("\\n");

  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Lelkigyakorlatok//HU",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${toIcsDate(new Date())}`,
    `DTSTART:${dtStart}`,
    `DTEND:${dtEnd}`,
    `SUMMARY:${(ev.title || "Lelkigyakorlat").replace(/\r?\n/g, " ")}`,
    `LOCATION:${(ev.location || "Magyarország").replace(/\r?\n/g, " ")}`,
    `DESCRIPTION:${desc.replace(/\r?\n/g, "\\n")}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
};

const downloadIcs = (ev) => {
  const ics = buildIcs(ev);
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const safeTitle = (ev.title || "lelkigyakorlat").replace(/\W+/g, "_").toLowerCase();
  a.download = `${safeTitle}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  gaEvent("add_to_calendar", { event_id: String(ev.id), title: ev.title || "" });
};

export default function EventList({ user, onEdit }) {
  const [events, setEvents] = useState([]);
  const [filter, setFilter] = useState("Mindenki");
  const [sourceFilter, setSourceFilter] = useState("mind");
  const [q, setQ] = useState("");
  const [month, setMonth] = useState("osszes");
  const [timeWindow, setTimeWindow] = useState("all"); // "all" | "30" | "90"
const [selectedEvent, setSelectedEvent] = useState(null);
const [detailsOpen, setDetailsOpen] = useState(false);
/*const [, setPosterSrc] = useState(null);*/


const openDetails = (ev) => {
  setSelectedEvent(ev);
  setDetailsOpen(true);
};
const closeDetails = () => {
  setDetailsOpen(false);
  // opcionális:
  // setSelectedEvent(null);
};
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(9);
 /* const [editEvent, setEditEvent] = useState(null);*/

  // Embed mód – minimal UI
  const isEmbed =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("embed") === "1"
      : false;

  // Közösség-szűrő
  const [communityFilter, setCommunityFilter] = useState(null); // {type:'id'|'slug', value:string} | null

  const toSlug = (s = "") =>
    s
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const communityNameToSlug = (name) => toSlug(name || "");

  const communityFilterLabel = (evs) => {
    if (!communityFilter) return null;
    if (communityFilter.type === "id") {
      const match = evs?.find(
        (e) => e?.communities?.id && String(e.communities.id) === String(communityFilter.value)
      );
      return match?.communities?.name || `Közösség #${communityFilter.value}`;
    }
    return communityFilter.value; // slug
  };

  const targetGroups = ["Fiatalok", "Mindenki", "Idősek", "Fiatal házasok", "Érett házasok", "Jegyesek", "Tinédzserek", "Családok", "Férfiak", "Nők"];

const MONTHS_HU = [
  { key: "1", label: "Január" },
  { key: "2", label: "Február" },
  { key: "3", label: "Március" },
  { key: "4", label: "Április" },
  { key: "5", label: "Május" },
  { key: "6", label: "Június" },
  { key: "7", label: "Július" },
  { key: "8", label: "Augusztus" },
  { key: "9", label: "Szeptember" },
  { key: "10", label: "Október" },
  { key: "11", label: "November" },
  { key: "12", label: "December" },
];

const TWChip = ({ active, children, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={[
      "tw-appearance-none tw-cursor-pointer tw-border tw-rounded-full tw-px-4 tw-py-2 tw-text-sm tw-leading-none",
      "tw-transition",
      active
        ? "tw-bg-blue-600 tw-text-white tw-border-blue-600 hover:tw-bg-blue-700 hover:tw-border-blue-700"
        : "tw-bg-white tw-text-blue-600 tw-font-semibold tw-border-blue-200 hover:tw-bg-blue-50",
    ].join(" ")}
  >
    {children}
  </button>
);


  // Query paramok beolvasása (embed/kezdeti szűrők/kommunity)
  useEffect(() => {
    if (typeof window === "undefined") return;
    const p = new URLSearchParams(window.location.search);
    const group = p.get("group");
    const m = p.get("month");
    const s = p.get("src");
    const q0 = p.get("q");
    const cid = p.get("communityId");
    const cslug = p.get("community");

    if (group) setFilter(group);
    if (m) setMonth(m);
    if (s) setSourceFilter(s);
    if (q0) setQ(q0);

    if (cid) setCommunityFilter({ type: "id", value: String(cid) });
    else if (cslug) setCommunityFilter({ type: "slug", value: toSlug(cslug) });

    setPage(0);
  }, []);

  useEffect(() => {
    fetchEvents();
    // eslint-disable-next-line
  }, [communityFilter]);

/*{ === Beágyazás (mini-widget) panel – csak nem-embed módban === }*/
/*{!isEmbed && (
  <div className="card border-0 shadow-sm my-3">
    <div className="card-body">
      <h5 className="card-title mb-2">Beágyazható mini-widget</h5>
      <p className="text-muted mb-2">
        Másold be az alábbi kódot a saját oldaladra. A widget csak a beállított közösség eseményeit mutatja.
      </p>

      {(() => {
        const base = "https://lelkigyakorlatok.vercel.app/";
        // alap paraméterek:
        const params = new URLSearchParams({ embed: "1" });
        // ha van community filter, adjuk hozzá
        if (communityFilter?.type === "id") params.set("communityId", String(communityFilter.value));
        if (communityFilter?.type === "slug") params.set("community", String(communityFilter.value));

        const srcId = `${base}?${params.toString()}`;
        const codeId = `<iframe src="${srcId}" style="width:100%;height:700px;border:0;overflow:hidden" loading="lazy"></iframe>`;

        // slug sablon (bemutató)
        const paramsSlug = new URLSearchParams({ embed: "1", community: "martineum" });
        const srcSlug = `${base}?${paramsSlug.toString()}`;
        const codeSlug = `<iframe src="${srcSlug}" style="width:100%;height:700px;border:0;overflow:hidden" loading="lazy"></iframe>`;

        const copy = async (txt) => {
          try {
            await navigator.clipboard.writeText(txt);
            alert("Beágyazási kód a vágólapon.");
          } catch {
            // no-op
          }
        };

        return (
          <div className="row g-3">
            <div className="col-md-8">
              <label className="form-label fw-semibold">
                Aktuális szűrőhöz illesztett kód {communityFilter ? "(közösség beállítva)" : "(jelenleg nincs közösség szűrő)"}
              </label>
              <textarea className="form-control" rows={3} value={codeId} readOnly />
            </div>
            <div className="col-md-4 d-flex align-items-end">
              <button className="btn btn-outline-primary ms-md-2 w-100" onClick={() => copy(codeId)}>
                Kód másolása
              </button>
            </div>

            <div className="col-md-8">
              <label className="form-label fw-semibold">Példa SLUG-gal (név alapján)</label>
              <textarea className="form-control" rows={3} value={codeSlug} readOnly />
              <div className="small text-muted mt-1">
                A <code>community=martineum</code> helyére írd be a saját közösséged slugját (pl. <em>martineum-felnottkepzo-akademia</em>).
              </div>
            </div>
            <div className="col-md-4 d-flex align-items-end">
              <button className="btn btn-outline-secondary ms-md-2 w-100" onClick={() => copy(codeSlug)}>
                Példa kód másolása
              </button>
            </div>
          </div>
        );
      })()}
    </div>
  </div>
)}
*/

  async function fetchEvents() {
    let base = supabase
      .from("events")
      .select(
        `
        id, title, location, description, start_date, end_date,
        contact, registration_link, target_group, source, created_by,
        image_url, poster_url, community_id,
        communities (id, name)
      `
      )
      .gte("start_date", new Date().toISOString())
      .order("start_date", { ascending: true });

    // ha communityId van, szűrjünk SQL-ben
    if (communityFilter?.type === "id") {
      base = base.eq("community_id", communityFilter.value);
    }

    let { data, error } = await base;

    if (error) {
      // fallback régi selectre ha image_url/poster_url nem létezne
      let fb = supabase
        .from("events")
        .select(
          `
          id, title, location, description, start_date, end_date,
          contact, registration_link, target_group, source, created_by,
          community_id,
          communities (id, name)
        `
        )
        .gte("start_date", new Date().toISOString())
        .order("start_date", { ascending: true });

      if (communityFilter?.type === "id") fb = fb.eq("community_id", communityFilter.value);
      ({ data, error } = await fb);
    }

    if (error) {
      console.error(error);
      setEvents([]);
    } else {
      setEvents(data || []);
    }
  }

  const isOwn = (e) => user && e.created_by === user.id;
  const isManual = (e) => !!e.created_by;
  const isAuto = (e) => !!e.source && !e.created_by;


  function formatDateRange(startISO, endISO) {
    if (!startISO) return "—";
    const opts = { year: "numeric", month: "long", day: "numeric" };
    const start = new Date(startISO).toLocaleDateString("hu-HU", opts);
    if (!endISO) return start;
    const end = new Date(endISO).toLocaleDateString("hu-HU", opts);
    return `${start} – ${end}`;
  }

  // Kategória fallback képek
  function groupSlug(group = "") {
    const repl = (s) =>
      s
        .replaceAll("á", "a")
        .replaceAll("é", "e")
        .replaceAll("í", "i")
        .replaceAll("ó", "o")
        .replaceAll("ö", "o")
        .replaceAll("ő", "o")
        .replaceAll("ú", "u")
        .replaceAll("ü", "u")
        .replaceAll("ű", "u");
    const base = repl((group || "").toLowerCase())
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
    if (base.includes("fiatal-hazas")) return "fiatalhazasok";
    if (base.includes("erett-hazas")) return "eretthazasok";
    if (base.includes("erett")) return "eretthazasok";
    if (base.includes("jegyes")) return "jegyesek";
    if (base.includes("tinedzs")) return "tinedzserek";
    if (base.includes("csalad")) return "csaladok";
    if (base.includes("idos")) return "idosek";
    if (base.includes("fiatal")) return "fiatalok";
    if (base.includes("mindenki")) return "mindenki";
    return "general";
  }

  const FALLBACKS = {
    fiatalok: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/fiatalok/fiatalok_01.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/fiatalok/fiatalok_02.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/fiatalok/fiatalok_03.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/fiatalok/fiatalok_04.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/fiatalok/fiatalok_05.jpg",
    ],
    jegyesek: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/jegyesek/jegyesek_01.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/jegyesek/jegyesek_02.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/jegyesek/jegyesek_03.jpg",
    ],
    fiatalhazasok: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/fiatalhazasok/fiatalhazasok_01.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/fiatalhazasok/fiatalhazasok_02.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/fiatalhazasok/fiatalhazasok_03.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/fiatalhazasok/fiatalhazasok_04.jpg",
    ],
    eretthazasok: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/eretthazasok/eretthazasok_01.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/eretthazasok/eretthazasok_02.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/eretthazasok/eretthazasok_03.jpg",
    ],
    csaladok: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/csaladok/csaladok_01.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/csaladok/csaladok_02.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/csaladok/csaladok_03.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/csaladok/csaladok_04.jpg",
    ],
    tinedzserek: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/tinedzserek/tinedzserek_01.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/tinedzserek/tinedzserek_02.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/tinedzserek/tinedzserek_03.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/tinedzserek/tinedzserek_04.jpg",
    ],
    idosek: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/idosek/idosek_01.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/idosek/idosek_02.jpg",
    ],
    mindenki: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/mindenki_01.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/mindenki_02.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/mindenki_03.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/mindenki_04.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/mindenki_05.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/mindenki_06.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/mindenki_07.jpg",
    ],
	ferfiak: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/ferfiak_1.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/ferfiak_2.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/ferfiak_3.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/ferfiak_4.jpg",
       ],
	 nok: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/nok_1.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/nok_2.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/nok_3.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/mindenki/nok_4.jpg",
       ], 
	   
    general: [
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/general/general_01.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/general/general_02.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/general/general_03.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/general/general_04.jpg",
      "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/fallback/general/general_05.jpg",
    ],
  };

  function hashStr(s = "") {
    let h = 0;
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return h;
  }
  function pickFallbackByGroup(event) {
    const slug = groupSlug(event?.target_group || "");
    const arr = FALLBACKS[slug]?.length ? FALLBACKS[slug] : FALLBACKS.general;
    const key = String(event?.id ?? event?.title ?? "");
    const idx = hashStr(key) % arr.length;
    return arr[idx];
  }
  const hasPoster = (e) => !!e.poster_url;
  function getCardImage(e) {
    if (e?.poster_url) return e.poster_url;
    if (e?.image_url) return e.image_url;
    return pickFallbackByGroup(e);
  }

  const filteredEvents = events.filter((event) => {
    // --- közösség szűrő ---
    if (communityFilter) {
      if (communityFilter.type === "id") {
        if (String(event?.communities?.id) !== String(communityFilter.value)) return false;
      } else if (communityFilter.type === "slug") {
        const evSlug = communityNameToSlug(event?.communities?.name || "");
        if (evSlug !== communityFilter.value) return false;
      }
    }

    // --- a meglévő szűrők ---
    if (filter === "sajat") {
      if (!isOwn(event)) return false;
    } else {
      if (filter !== "Mindenki" && event.target_group !== filter) return false;
    }
    if (sourceFilter === "kezi" && !isManual(event)) return false;
    if (sourceFilter === "auto" && !isAuto(event)) return false;
    if (q) {
      const t = (event.title || "").toLowerCase();
      const l = (event.location || "").toLowerCase();
      const needle = q.toLowerCase();
      if (!t.includes(needle) && !l.includes(needle)) return false;
    }
	
	  // ÚJ: időablak (30 / 90 nap)
  if (timeWindow !== "all" && event.start_date) {
    const now = new Date();
    const start = new Date(event.start_date);
    const diffDays = (start.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);

    if (timeWindow === "30" && diffDays > 30) return false;
    if (timeWindow === "90" && diffDays > 90) return false;
  }
  
    if (month !== "osszes") {
      const m = new Date(event.start_date).getMonth() + 1;
      if (String(m) !== month) return false;
    }
    return true;
  });

  const total = filteredEvents.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const startIndex = page * pageSize;
  const endIndex = Math.min(startIndex + pageSize, total);
  const paginatedEvents = filteredEvents.slice(startIndex, endIndex);

  function getVisiblePages() {
    const max = totalPages - 1,
      win = 2;
    let start = Math.max(0, page - win),
      end = Math.min(max, page + win);
    const items = [];
    const addPage = (n) => items.push({ type: "page", n });
    const addDots = (k) => items.push({ type: "dots", k });
    if (start > 0) {
      addPage(0);
      if (start > 1) addDots("l");
    }
    for (let n = start; n <= end; n++) addPage(n);
    if (end < max) {
      if (end < max - 1) addDots("r");
      addPage(max);
    }
    return items;
  }


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page, pageSize, filter, sourceFilter, q, month, communityFilter]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const eid = params.get("e");
    if (!eid || !events?.length) return;
    const ev = events.find((x) => String(x.id) === String(eid));
    if (ev) {
	  setSelectedEvent(ev);
	  setDetailsOpen(true);
	};
  }, [events]);

  const pageTitle =
    filter === "Mindenki"
      ? "Katolikus lelkigyakorlat-kereső – friss események"
      : `Lelkigyakorlatok – ${filter.toLowerCase()} célcsoport`;
  const pageDesc =
    "Friss katolikus lelkigyakorlatok egy helyen. Szűrés célcsoport, hónap, forrás és közösség szerint – jelentkezési linkekkel.";
  const url = typeof window !== "undefined" ? window.location.href.split("#")[0] : CANONICAL_BASE;

  const first = paginatedEvents?.[0];
 // const ogTitle = first?.title || "Lelkigyakorlatok";
  const OG_FALLBACK =
    "https://kibgskyyevsighwtkqcf.supabase.co/storage/v1/object/public/event-images/og/og_1.jpg";
  const ogImage = first?.poster_url ? first.poster_url : OG_FALLBACK;

  function iconSvgForGroup(group = "") {
    const g = (group || "").toLowerCase();
    const stroke = "#0f172a",
      sw = 3.5,
      fillSoft = "#0f172a";
    if (g.includes("jegyes"))
      return `<circle cx="26" cy="32" r="10" fill="none" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round"/><circle cx="38" cy="32" r="10" fill="none" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round"/>`;
    if (g.includes("házas"))
      return `<path d="M32 48 C18 36, 20 24, 32 28 C44 24, 46 36, 32 48 Z" fill="${fillSoft}" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round"/>`;
    if (g.includes("család"))
      return `<circle cx="22" cy="28" r="7" fill="${fillSoft}"/><circle cx="42" cy="28" r="7" fill="${fillSoft}"/><circle cx="32" cy="36" r="5" fill="${fillSoft}"/>`;
    if (g.includes("idős"))
      return `<path d="M20 44 C20 28, 44 28, 44 44 C44 50, 20 50, 20 44 Z" fill="none" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 44 C26 40, 34 40, 44 44" fill="none" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round"/>`;
    if (g.includes("tinédzs"))
      return `<path d="M32 16 L24 34 H32 L28 52 L44 28 H36 L40 16 Z" fill="${fillSoft}" />`;
    if (g.includes("fiatal"))
      return `<path d="M32 18 L36 28 L46 32 L36 36 L32 46 L28 36 L18 32 L28 28 Z" fill="none" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round"/>`;
    return `<path d="M20 32 L32 22 L44 32" fill="none" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round"/><rect x="22" y="32" width="20" height="18" rx="3" fill="none" stroke="${stroke}" stroke-width="${sw}" /><line x1="32" y1="16" x2="32" y2="22" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round"/><line x1="29" y1="19" x2="35" y1="19" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round"/>`;
  }

  const onNativeShare = async (ev) => {
    try {
      const landing = makeLanding(ev, "native");
      await navigator.share({
        title: buildEmailSubject(ev),
        text: ev?.title || "",
        url: landing,
      });
    } catch {
      // cancel/no-op
    }
  };

  return (
    <div className="container mt-4">
      <Seo title={pageTitle} description={pageDesc} url={url} image={ogImage} />

      {/* WebSite JSON-LD – egyszerű globális séma */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Katolikus lelkigyakorlat-kereső",
            url: "https://lelkigyakorlatok.vercel.app/",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://lelkigyakorlatok.vercel.app/?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />

      {/* ItemList + egyedi Event JSON-LD a látható listához */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(buildItemListJsonLd(paginatedEvents, CANONICAL_BASE)),
        }}
      />
      {paginatedEvents.map((ev) => (
        <script
          key={`jsonld-${ev.id}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(buildEventJsonLd(ev, CANONICAL_BASE)) }}
        />
      ))}

      {!user && !isEmbed && (
        <div className="alert alert-info text-center">
          Szeretnél lelkigyakorlatot létrehozni? Ehhez kérjük, jelentkezz be. Ha viszont csak nézelődnél vagy keresnél, azt bejelentkezés nélkül is megteheted.
        </div>
      )}
{/*
      {!isEmbed && (
        <div className="text-center mb-4">
          <img src={headerImage} alt="Katolikus lelkigyakorlat" className="img-fluid rounded" />
          <h1 className="mt-3">Katolikus Lelkigyakorlat-kereső</h1>
          <h4>Találd meg azt a lelkigyakorlatot, ami neked szól!</h4>
        </div>
      )}*/}
	  {!isEmbed && (
		  <section
			style={{
			  marginLeft: "calc(50% - 50vw)",
			  marginRight: "calc(50% - 50vw)",
			  width: "100vw",
			}}
			className="tw-relative tw-bg-white"
		  >
			{/* HERO KÉP RÉSZ (fix magasság) */}
			<div className="tw-relative tw-h-[320px] sm:tw-h-[380px] md:tw-h-[480px] tw-overflow-hidden">

			  <div className="tw-absolute tw-inset-0">
				<div
				  className="tw-h-full tw-w-full tw-bg-cover tw-bg-no-repeat tw-bg-[position:82%_15%] md:tw-bg-center"
				  style={{ backgroundImage: `url(${headerImage})` }}
				/>


				<div className="tw-absolute tw-inset-0 tw-bg-slate-900/65" />
			  </div>

			  <div className="tw-relative tw-mx-auto tw-max-w-6xl tw-px-4 tw-pt-14 tw-pb-20">
				<div className="tw-flex tw-justify-center">
				  <span className="tw-inline-flex tw-items-center tw-rounded-full tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-sm tw-text-white">
					Találd meg a belső békéd
				  </span>
				</div>

				<h1 className="tw-mt-6 tw-text-center tw-text-4xl md:tw-text-6xl tw-font-bold tw-text-white">
				  Katolikus <span className="tw-text-blue-400">Lelkigyakorlat</span>-kereső
				</h1>

				<p className="tw-mx-auto tw-mt-4 tw-max-w-2xl tw-text-center tw-text-slate-200">
				  Fedezd fel a csend erejét. Válogass számos katolikus lelkigyakorlat közül, és találd meg azt, ami most neked szól.
				</p>
			  </div>
			</div>

			{/* KERESŐKÁRTYA – már a kép alá kerül, és kicsit fel van húzva */}
			<div className="tw-relative tw-mx-auto tw-max-w-4xl tw-px-4 tw-mt-[-220px]">
			  <div className="tw-rounded-3xl tw-bg-white tw-p-6 tw-shadow-xl">
				{/* input */}
				<div className="tw-flex tw-items-center tw-gap-3 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-4 tw-py-3">
				  <svg viewBox="0 0 24 24" className="tw-h-5 tw-w-5 tw-text-slate-400" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
					<path d="M21 21l-4.35-4.35" />
					<circle cx="11" cy="11" r="7" />
				  </svg>

				  <input
					value={q}
					onChange={(e) => {
					  setQ(e.target.value);
					  setPage(0);
					}}
					placeholder="Keresés cím vagy helyszín szerint..."
					className="tw-w-full tw-bg-transparent tw-border-0 tw-outline-none tw-text-slate-900 placeholder:tw-text-slate-400"
				  />
				</div>

				{/* szűrők lejjebb + elválasztó */}
				<div className="tw-mt-8 tw-border-t tw-border-slate-200 tw-pt-6 tw-flex tw-flex-col tw-gap-4">
				  {/* hónapok */}
				  <div className="tw-flex tw-flex-wrap tw-gap-2">
					<TWChip active={month === "osszes"} onClick={() => { setMonth("osszes"); setPage(0); }}>
					  Összes hónap
					</TWChip>

					{MONTHS_HU.map((m) => (
					  <TWChip key={m.key} active={month === m.key} onClick={() => { setMonth(m.key); setPage(0); }}>
						{m.label}
					  </TWChip>
					))}
				  </div>

				  {/* időablak */}
				  <div className="tw-flex tw-flex-wrap tw-gap-2">
					<TWChip active={timeWindow === "all"} onClick={() => { setTimeWindow("all"); setPage(0); }}>
					  Összes időpont
					</TWChip>
					<TWChip active={timeWindow === "30"} onClick={() => { setTimeWindow("30"); setPage(0); }}>
					  Következő 30 nap
					</TWChip>
					<TWChip active={timeWindow === "90"} onClick={() => { setTimeWindow("90"); setPage(0); }}>
					  Következő 90 nap
					</TWChip>
				  </div>
				</div>
			  </div>
			</div>
		  </section>
		)}



      {/* ===== Tailwind layout (Bootstrap row/col kiváltása) ===== */}
<div className="tw-mt-6 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-6">
  {/* Bal oldali szűrők – embed módban rejtve */}
  {!isEmbed && (
    <aside className="md:tw-col-span-3">
      <div className="tw-sticky tw-top-24">
        <div className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-shadow-sm">
          {/* Közösség-szűrő infó */}
          {communityFilter && (
            <div className="tw-mb-4 tw-flex tw-items-start tw-justify-between tw-gap-3 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-p-3">
              <div className="tw-text-sm tw-text-slate-700">
                <div className="tw-font-semibold">
                  Közösség szűrő:{" "}
                  <span className="tw-font-normal">{communityFilterLabel(events)}</span>
                </div>
                <div className="tw-mt-1 tw-text-xs tw-text-slate-500">
                  ({communityFilter.type === "id" ? "ID alapján" : "név/slug alapján"})
                </div>
              </div>

              <button
                type="button"
                className="tw-appearance-none tw-border tw-border-slate-300 tw-bg-white tw-rounded-lg tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-700 hover:tw-bg-slate-100"
                onClick={() => {
                  setCommunityFilter(null);
                  setPage(0);
                }}
              >
                Szűrő törlése
              </button>
            </div>
          )}

          {/* Célcsoport */}
          <div className="tw-text-sm tw-font-semibold tw-text-slate-800">Célcsoport</div>

          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            {targetGroups.map((group) => {
              const active = filter === group;
              return (
                <button
                  key={group}
                  type="button"
                  className={[
                    "tw-w-full tw-appearance-none tw-rounded-xl tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition",
                    active
                      ? "tw-bg-blue-600 tw-text-white tw-border-blue-600"
                      : "tw-bg-white tw-text-slate-700 tw-border-slate-200 hover:tw-bg-slate-50",
                  ].join(" ")}
                  onClick={() => {
                    setFilter(group);
                    setPage(0);
                    setSelectedEvent(null);
                  }}
                >
                  {group}
                </button>
              );
            })}

            {user && (
              <button
                type="button"
                className={[
                  "tw-mt-2 tw-w-full tw-appearance-none tw-rounded-xl tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition",
                  filter === "sajat"
                    ? "tw-bg-emerald-600 tw-text-white tw-border-emerald-600"
                    : "tw-bg-white tw-text-emerald-700 tw-border-emerald-200 hover:tw-bg-emerald-50",
                ].join(" ")}
                onClick={() => {
                  setFilter("sajat");
                  setPage(0);
                  setSelectedEvent(null);
                }}
              >
                Saját eseményeim
              </button>
            )}
          </div>

          <div className="tw-my-5 tw-border-t tw-border-slate-200" />

          {/* Forrás */}
          <div className="tw-text-sm tw-font-semibold tw-text-slate-800">Forrás</div>

          <div className="tw-mt-3 tw-flex tw-flex-col tw-gap-2">
            <button
              type="button"
              className={[
                "tw-w-full tw-appearance-none tw-rounded-xl tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition",
                sourceFilter === "mind"
                  ? "tw-bg-slate-900 tw-text-white tw-border-slate-900"
                  : "tw-bg-white tw-text-slate-700 tw-border-slate-200 hover:tw-bg-slate-50",
              ].join(" ")}
              onClick={() => {
                setSourceFilter("mind");
                setPage(0);
              }}
            >
              Mind
            </button>

            <button
              type="button"
              className={[
                "tw-w-full tw-appearance-none tw-rounded-xl tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition",
                sourceFilter === "kezi"
                  ? "tw-bg-blue-600 tw-text-white tw-border-blue-600"
                  : "tw-bg-white tw-text-blue-700 tw-border-blue-200 hover:tw-bg-blue-50",
              ].join(" ")}
              onClick={() => {
                setSourceFilter("kezi");
                setPage(0);
              }}
            >
              Kézi
            </button>

            <button
              type="button"
              className={[
                "tw-w-full tw-appearance-none tw-rounded-xl tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-transition",
                sourceFilter === "auto"
                  ? "tw-bg-slate-700 tw-text-white tw-border-slate-700"
                  : "tw-bg-white tw-text-slate-700 tw-border-slate-200 hover:tw-bg-slate-50",
              ].join(" ")}
              onClick={() => {
                setSourceFilter("auto");
                setPage(0);
              }}
            >
              Automatikus
            </button>
          </div>

          {/* Legend */}
          <div className="tw-mt-4 tw-text-xs tw-text-slate-500 tw-space-y-2">
            <div className="tw-flex tw-items-center tw-gap-2">
              <span className="tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-600 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold tw-text-white">
                Saját
              </span>
              – általad felvitt
            </div>

            <div className="tw-flex tw-items-center tw-gap-2">
              <span className="tw-inline-flex tw-items-center tw-rounded-full tw-bg-blue-600 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold tw-text-white">
                Kézi
              </span>
              – más által felvitt
            </div>

            <div className="tw-flex tw-items-center tw-gap-2">
              <span className="tw-inline-flex tw-items-center tw-rounded-full tw-bg-slate-500 tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold tw-text-white">
                Automatikus
              </span>
              – RSS/gyűjtő
            </div>
          </div>
        </div>
      </div>
    </aside>
  )}

  {/* Jobb oldal: lista */}
  <main className={isEmbed ? "md:tw-col-span-12" : "md:tw-col-span-9"}>
    {/* Embed módban közösség-szűrő jelzés + törlés */}
    {isEmbed && communityFilter && (
      <div className="tw-mb-4 tw-flex tw-items-start tw-justify-between tw-gap-3 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-p-3">
        <div className="tw-text-sm tw-text-slate-700">
          <div className="tw-font-semibold">
            Közösség szűrő:{" "}
            <span className="tw-font-normal">{communityFilterLabel(events)}</span>
          </div>
          <div className="tw-mt-1 tw-text-xs tw-text-slate-500">
            ({communityFilter.type === "id" ? "ID alapján" : "név/slug alapján"})
          </div>
        </div>

        <button
          type="button"
          className="tw-appearance-none tw-border tw-border-slate-300 tw-bg-white tw-rounded-lg tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-700 hover:tw-bg-slate-100"
          onClick={() => {
            setCommunityFilter(null);
            setPage(0);
          }}
        >
          Szűrő törlése
        </button>
      </div>
    )}

    {/* Embed módban legyen kereső + hónap + időablak */}
    {isEmbed && (
      <div className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-shadow-sm">
        {/* kereső */}
        <div className="tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-4 tw-py-3">
          <svg viewBox="0 0 24 24" className="tw-h-5 tw-w-5 tw-text-slate-400" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M21 21l-4.35-4.35" />
            <circle cx="11" cy="11" r="7" />
          </svg>

          <input
            value={q}
            onChange={(e) => {
              setQ(e.target.value);
              setPage(0);
            }}
            placeholder="Keresés cím vagy helyszín szerint…"
            className="tw-w-full tw-bg-transparent tw-border-0 tw-outline-none tw-text-slate-900 placeholder:tw-text-slate-400"
          />
        </div>

        {/* szűrők */}
        <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-3">
          {/* hónapok */}
          <div className="tw-flex tw-flex-wrap tw-gap-2">
            {[
              { key: "osszes", label: "Összes hónap" },
              { key: "1", label: "Január" },
              { key: "2", label: "Február" },
              { key: "3", label: "Március" },
              { key: "4", label: "Április" },
              { key: "5", label: "Május" },
              { key: "6", label: "Június" },
              { key: "7", label: "Július" },
              { key: "8", label: "Augusztus" },
              { key: "9", label: "Szeptember" },
              { key: "10", label: "Október" },
              { key: "11", label: "November" },
              { key: "12", label: "December" },
            ].map((m) => {
              const active = month === m.key;
              return (
                <button
                  key={m.key}
                  type="button"
                  className={[
                    "tw-appearance-none tw-cursor-pointer tw-border tw-rounded-full tw-px-4 tw-py-2 tw-text-sm tw-leading-none tw-transition",
                    active
                      ? "tw-bg-blue-600 tw-text-white tw-border-blue-600 hover:tw-bg-blue-700 hover:tw-border-blue-700"
                      : "tw-bg-white tw-text-blue-600 tw-font-semibold tw-border-blue-200 hover:tw-bg-blue-50",
                  ].join(" ")}
                  onClick={() => {
                    setMonth(m.key);
                    setPage(0);
                  }}
                >
                  {m.label}
                </button>
              );
            })}
          </div>

          {/* időablak */}
          <div className="tw-flex tw-flex-wrap tw-gap-2">
            {[
              { key: "all", label: "Összes időpont" },
              { key: "30", label: "Következő 30 nap" },
              { key: "90", label: "Következő 90 nap" },
            ].map((w) => {
              const active = timeWindow === w.key;
              return (
                <button
                  key={w.key}
                  type="button"
                  className={[
                    "tw-appearance-none tw-cursor-pointer tw-border tw-rounded-full tw-px-4 tw-py-2 tw-text-sm tw-leading-none tw-transition",
                    active
                      ? "tw-bg-blue-600 tw-text-white tw-border-blue-600 hover:tw-bg-blue-700 hover:tw-border-blue-700"
                      : "tw-bg-white tw-text-blue-600 tw-font-semibold tw-border-blue-200 hover:tw-bg-blue-50",
                  ].join(" ")}
                  onClick={() => {
                    setTimeWindow(w.key);
                    setPage(0);
                  }}
                >
                  {w.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    )}

    {/* Tailwind pager (a renderPager() helyett) */}
    <div className="tw-mt-6 tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center sm:tw-justify-between tw-gap-3">
      <div className="tw-text-sm tw-text-slate-500">
        Eredmények: {total === 0 ? 0 : startIndex + 1}–{endIndex} / {total}
      </div>

      <div className="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
        <select
          className="tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm"
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setPage(0);
          }}
        >
          <option value={9}>9 / oldal</option>
          <option value={12}>12 / oldal</option>
          <option value={24}>24 / oldal</option>
        </select>

        <div className="tw-flex tw-items-center tw-gap-1">
          <button
            type="button"
            className="tw-appearance-none tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-slate-50 disabled:tw-opacity-50"
            disabled={page === 0}
            onClick={() => setPage(0)}
          >
            «
          </button>
          <button
            type="button"
            className="tw-appearance-none tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-slate-50 disabled:tw-opacity-50"
            disabled={page === 0}
            onClick={() => setPage((p) => Math.max(0, p - 1))}
          >
            ‹
          </button>

          {getVisiblePages().map((it, i) =>
            it.type === "dots" ? (
              <span key={`dots-${it.k}-${i}`} className="tw-px-2 tw-text-slate-400">
                …
              </span>
            ) : (
              <button
                key={it.n}
                type="button"
                className={[
                  "tw-appearance-none tw-rounded-lg tw-border tw-px-3 tw-py-2 tw-text-sm tw-transition",
                  it.n === page
                    ? "tw-bg-slate-900 tw-text-white tw-border-slate-900"
                    : "tw-bg-white tw-text-slate-700 tw-border-slate-200 hover:tw-bg-slate-50",
                ].join(" ")}
                onClick={() => setPage(it.n)}
              >
                {it.n + 1}
              </button>
            )
          )}

          <button
            type="button"
            className="tw-appearance-none tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-slate-50 disabled:tw-opacity-50"
            disabled={page >= totalPages - 1}
            onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
          >
            ›
          </button>
          <button
            type="button"
            className="tw-appearance-none tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-slate-50 disabled:tw-opacity-50"
            disabled={page >= totalPages - 1}
            onClick={() => setPage(totalPages - 1)}
          >
            »
          </button>
        </div>
      </div>
    </div>

    {paginatedEvents.length === 0 && (
      <div className="tw-mt-4 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-p-4 tw-text-sm tw-text-slate-700">
        Nincs találat ezekkel a szűrőkkel. Próbáld módosítani a keresőt vagy a hónapot.
      </div>
    )}

    {/* Kártya grid */}
    <div className="tw-mt-4 tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4">
      {paginatedEvents.map((event) => {
        const imgSrc = getCardImage(event);
        const iconSvg = iconSvgForGroup(event.target_group);

        const own = typeof isOwn === "function" ? isOwn(event) : false;
        const auto = typeof isAuto === "function" ? isAuto(event) : false;
        const manual = typeof isManual === "function" ? isManual(event) : false;

        const borderClass = own
          ? "tw-border-emerald-300"
          : auto
          ? "tw-border-slate-300"
          : manual
          ? "tw-border-blue-300"
          : "tw-border-slate-200";

        const badge = own ? "Saját" : auto ? "Automatikus" : manual ? "Kézi" : null;
        const badgeClass = own
          ? "tw-bg-emerald-600"
          : auto
          ? "tw-bg-slate-500"
          : manual
          ? "tw-bg-blue-600"
          : "";

        return (
          <div
			  key={event.id}
			  role="button"
			  tabIndex={0}
			  onClick={() => openDetails(event)}
			  onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
				  e.preventDefault();
				  openDetails(event);
				}
			  }}
            className={[
              "tw-rounded-2xl tw-border tw-bg-white tw-shadow-sm tw-overflow-hidden tw-transition hover:tw-shadow-md tw-transition hover:tw-shadow-md tw-group hover:tw--translate-y-0.5 tw-group",
              borderClass,
            ].join(" ")}
          >
            {/* fejléc kép + ikon */}
            <div className="tw-relative">
              <img
                src={imgSrc}
                alt={`${event.title} – illusztráció vagy poszter`}
                className="tw-h-[230px] tw-w-full tw-object-cover tw-object-[50%_20%] tw-transition-transform tw-duration-300 group-hover:tw-scale-105"
                loading="lazy"
                style={{ cursor: hasPoster(event) ? "zoom-in" : "pointer" }}
                
              />

              {/* célcsoport ikon buborék */}
              <div
                className="tw-absolute tw-left-3 tw-top-3 tw-h-11 tw-w-11 tw-rounded-xl tw-bg-white/95 tw-shadow tw-flex tw-items-center tw-justify-center"
                onClick={(e) => e.stopPropagation()}
                aria-hidden="true"
              >
                <svg width="32" height="32" viewBox="0 0 64 64" aria-hidden="true">
                  <g dangerouslySetInnerHTML={{ __html: iconSvg }} />
                </svg>
              </div>
            </div>

            <div className="tw-p-4">
              <div className="tw-flex tw-items-start tw-justify-between tw-gap-2">
                <h3 className="tw-text-base tw-font-semibold tw-text-slate-900 tw-leading-snug group-hover:tw-text-blue-600 tw-transition-colors">
                  {event.title}
                </h3>

                {badge && (
                  <span className={`tw-inline-flex tw-items-center tw-rounded-full ${badgeClass} tw-px-2 tw-py-1 tw-text-[11px] tw-font-semibold tw-text-white`}>
                    {badge}
                  </span>
                )}
              </div>

              <div className="tw-mt-2 tw-text-sm tw-text-slate-600">
                {event.location || "—"} — {formatDateRange(event.start_date, event.end_date)}
              </div>

              {/* gombsor + share */}
              <div className="tw-mt-3 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2">
                <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                  <button
                    type="button"
                    className="tw-appearance-none tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-700 hover:tw-bg-slate-50"
                    onClick={(e) => {
                      e.stopPropagation();
                      downloadIcs(event);
                    }}
                    title="Naptárba"
                  >
                    <CalendarIcon />
                    Naptárba
                  </button>

                  {event.registration_link && (
                    <a
                      href={event.registration_link}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => {
                        e.stopPropagation();
                        gaEvent("registration_click", {
                          event_category: "engagement",
                          event_label: event.title || "",
                          value: 1,
                          event_id: String(event.id),
                          target_group: event.target_group || "",
                          source: event.source || "",
                        });
                      }}
                      className="tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-blue-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-blue-700 hover:tw-bg-blue-50 tw-no-underline"
                    >
                      Jelentkezés
                    </a>
                  )}

                  <button
                    type="button"
                    className="tw-appearance-none tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-blue-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-blue-700 hover:tw-bg-blue-50"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (event?.id) window.location.href = `/terkep?event=${event.id}`;
                    }}
                  >
                    🗺️ Térképen
                  </button>

                  {user && event.created_by === user.id && (
                    <button
                      type="button"
                      className="tw-appearance-none tw-inline-flex tw-items-center tw-rounded-xl tw-bg-amber-500 tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white hover:tw-bg-amber-600"
                      onClick={(e) => {
                        e.stopPropagation();
                        onEdit?.(event);
                      }}
                    >
                      ✏️ Szerkesztés
                    </button>
                  )}
                </div>

                {/* megosztás ikonok */}
                <div className="tw-flex tw-items-center tw-gap-2">
                  {canWebShare && (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        gaShare("native", event);
                        onNativeShare(event);
                      }}
                      className="tw-appearance-none tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white hover:tw-bg-slate-50"
                      title="Megosztás (telefon)"
                      aria-label="Megosztás (telefon)"
                    >
                      <IconShareNative />
                    </button>
                  )}

                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(makeLanding(event, "facebook"))}`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      e.stopPropagation();
                      gaShare("facebook", event);
                    }}
                    className="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white hover:tw-bg-slate-50 tw-no-underline"
                    title="Megosztás Facebookon"
                    aria-label="Megosztás Facebookon"
                  >
                    <IconFacebook />
                  </a>

                  <a
                    href={`https://wa.me/?text=${encodeURIComponent(`${event.title} ${makeLanding(event, "whatsapp")}`)}`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      e.stopPropagation();
                      gaShare("whatsapp", event);
                    }}
                    className="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white hover:tw-bg-slate-50 tw-no-underline"
                    title="Megosztás WhatsAppon"
                    aria-label="Megosztás WhatsAppon"
                  >
                    <IconWhatsApp />
                  </a>

                  {/* Gmail – megtartva a piros “badge”-et */}
                  <span style={{ position: "relative", display: "inline-block" }}>
                    <a
                      href={buildGmailShare(event)}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => {
                        e.stopPropagation();
                        gaShare("gmail", event);
                      }}
                      className="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-full tw-border tw-no-underline"
                      title="Megnyitás Gmailben"
                      aria-label="Megnyitás Gmailben"
                      style={{
                        borderColor: "#ea4335",
                        color: "#ea4335",
                        backgroundColor: "#fce8e6",
                      }}
                    >
                      <IconGmail />
                    </a>
                    <span
                      style={{
                        position: "absolute",
                        right: -2,
                        bottom: -2,
                        background: "#ea4335",
                        color: "#fff",
                        borderRadius: 6,
                        fontSize: 10,
                        lineHeight: "12px",
                        padding: "0 4px",
                        fontWeight: 700,
                        pointerEvents: "none",
                      }}
                    >
                      G
                    </span>
                  </span>

                  <a
                    href={buildMailto(event)}
                    onClick={(e) => {
                      e.stopPropagation();
                      gaShare("email", event);
                    }}
                    className="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white hover:tw-bg-slate-50 tw-no-underline"
                    title="Megosztás e-mailben"
                    aria-label="Megosztás e-mailben"
                  >
                    <IconMail />
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      })}
		<EventDetailsModalTW
		  open={detailsOpen}
		  event={selectedEvent}
		 onClose={closeDetails}
		/>   
   </div>

    {/* Tailwind pager alul is */}
    <div className="tw-mt-6">
      <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center sm:tw-justify-between tw-gap-3">
        <div className="tw-text-sm tw-text-slate-500">
          Eredmények: {total === 0 ? 0 : startIndex + 1}–{endIndex} / {total}
        </div>

        <div className="tw-flex tw-items-center tw-gap-1">
          <button
            type="button"
            className="tw-appearance-none tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-slate-50 disabled:tw-opacity-50"
            disabled={page === 0}
            onClick={() => setPage(0)}
          >
            «
          </button>
          <button
            type="button"
            className="tw-appearance-none tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-slate-50 disabled:tw-opacity-50"
            disabled={page === 0}
            onClick={() => setPage((p) => Math.max(0, p - 1))}
          >
            ‹
          </button>

          {getVisiblePages().map((it, i) =>
            it.type === "dots" ? (
              <span key={`dots2-${it.k}-${i}`} className="tw-px-2 tw-text-slate-400">
                …
              </span>
            ) : (
              <button
                key={`p2-${it.n}`}
                type="button"
                className={[
                  "tw-appearance-none tw-rounded-lg tw-border tw-px-3 tw-py-2 tw-text-sm tw-transition",
                  it.n === page
                    ? "tw-bg-slate-900 tw-text-white tw-border-slate-900"
                    : "tw-bg-white tw-text-slate-700 tw-border-slate-200 hover:tw-bg-slate-50",
                ].join(" ")}
                onClick={() => setPage(it.n)}
              >
                {it.n + 1}
              </button>
            )
          )}

          <button
            type="button"
            className="tw-appearance-none tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-slate-50 disabled:tw-opacity-50"
            disabled={page >= totalPages - 1}
            onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
          >
            ›
          </button>
          <button
            type="button"
            className="tw-appearance-none tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm hover:tw-bg-slate-50 disabled:tw-opacity-50"
            disabled={page >= totalPages - 1}
            onClick={() => setPage(totalPages - 1)}
          >
            »
          </button>
        </div>
      </div>
    </div>
  </main>

</div>
{/* ===== /Tailwind layout ===== */}
</div>
  );
}